import PropTypes from "prop-types"
import { useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campus, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { consent, defaultValues, getCampus } from "services"

const Form = ({ parent = false }) => {
  // TODO: renseigner le product_id de la campagne Livre Blanc étudiant
  const productId = parent ? 'LB_1_ESME' : ''
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('ESME-LB-PARENT')
  const { url: url_etudiant } = useUrlReturn('ESME-LB-ETUDIANT')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      campaignId: '',
      lead: {
        ...defaultValues,
        AcademicLevel__c: parent ? 'Autre': '',
        MobilePhone: '',
      },
    },
    resolver: yupResolver(schema, { context: { parent } })
  })
  const { control, setValue, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const defaultDataLead = {
      Division__c: 'ESME',
      IONISSchool__c: 'ESME',
      LastForm__c: parent ? 'Documentation PDF - LB Parents' : 'Documentation PDF - LB Etudiants',
      LeadSource: 'Internet: Demande de doc',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      await submission({
          formId: 'DOC',
          lead: finalLead,
          campaignId: campaignId,
          campaignStatus: 'Active',
          utmCookieName: '_ionis_user_data' // optionnel
        })
      if (parent) {
        document.location.href=`${url}?ville=${campus}&campaignId=${campaignId}`
      } else {
        document.location.href=`${url_etudiant}?ville=${campus}&campaignId=${campaignId}`
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useEffect(() => {
    if (salesforce !== null && productId) {
      const getData = async () => {
        const campaign = await salesforce.getCampaign(productId)
        return { campaign }
      }
      getData().then((value) => {
        const { campaign } = value
        setValue('campaignId', campaign.Id)
      }).catch((error) => {
        setError('Une erreur est survenue lors du chargement du formulaire', error)
      })
    }
  }, [salesforce, productId, setError, setValue])
  useSalesforce('EngineeringSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        {!parent && (
          <AcademicLevel school="ESME" section={false} specialites={false} />
        )}
        <Grid item sm={12} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone mobile" required />
        </Grid>
        <Campus label="Campus d’intérêt" options={getCampus('ESME')} />
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Livre Blanc" school="ESME" />
      </Grid>
    </FormProvider>
  )
}

Form.propTypes = {
  parent: PropTypes.bool
}

export default Form
